import { Badge, Button } from '@mui/material';
import styled from '@emotion/styled';

// Utility function to format date as DD-MM-YYYY
const formatDate = (date) => {
  const d = new Date(date);
  let month = '' + (d.getMonth() + 1);
  let day = '' + d.getDate();
  const year = d.getFullYear();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  return [day, month, year].join('-');
}

const isToday = (date) => {
  if (!date) return false;
  return formatDate(date) === formatDate(new Date());
};

// Styled components
const HighlightedCell = styled('div')(({ bgcolor }) => ({
  backgroundColor: bgcolor,
  color: '#fff',
  padding: '4px 8px',
  borderRadius: '4px',
  display: 'inline-block',
}));



const StyledBadge = styled(Badge)(({ bg }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: bg || '#ccc',
    color: '#fff',
    minWidth: '90px',
    height: '30px',
    fontSize: '12px',
    padding: '0 8px',
    borderRadius: '4.5px',
    lineHeight: '28px',
    fontWeight: 700,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 8px',
    whiteSpace: 'nowrap',
  }
}));

// Status badge component
const StatusBadge = ({ status }) => {
  const config = {
    'Pending': { backgroundColor: "#FFA756", text: 'Pending' },
    'Canceled': { backgroundColor: "#FF3B30", text: 'Canceled' },
    'Completed': { backgroundColor: "#00B69B", text: 'Completed' },
    'default': { backgroundColor: "#9E9E9E", text: status || 'Unknown' }
  }[status] || {
    backgroundColor: "#9E9E9E",
    text: status || 'Unknown'
  };

  return (
    <Button sx={{ p: 0, minWidth: 'auto', textTransform: 'none' }}>
      <StyledBadge
        badgeContent={config.text}
        bg={config.backgroundColor}
        overlap="circular"
      />
    </Button>
  );
};

export default function TableData() {
  const formReservationListRows = (data) => {
    return data.map((dt) => {
      const reported = dt.reported_time ? new Date(dt.reported_time) : null;
      const resolved = dt.resolved_time ? new Date(dt.resolved_time) : null;

      let resolutionTime = ""; // default value

      if (reported && resolved && resolved > reported) {
        const diffMs = resolved - reported;
        const diffMins = Math.floor(diffMs / (1000 * 60));

        const days = Math.floor(diffMins / (60 * 24));
        const hours = Math.floor((diffMins % (60 * 24)) / 60);
        const minutes = diffMins % 60;

        const parts = [];

        if (days > 0) {
          parts.push(`${days} day${days > 1 ? 's' : ''}`);
          if (hours > 0) parts.push(`${hours} hr${hours > 1 ? 's' : ''}`);
        } else {
          if (hours > 0) parts.push(`${hours} hr${hours > 1 ? 's' : ''}`);
          if (minutes > 0 || parts.length === 0) parts.push(`${minutes} min${minutes > 1 ? 's' : ''}`);
        }

        resolutionTime = parts.join(" ");
      }

      return {
        request_id: dt.name,
        room_no: dt.room_name,
        room_type: dt.room_type,
        issue_category: dt.issue_category_name?.category_name,
        priority: dt.priority,
        status: <StatusBadge status={dt.status} />,
        reported_by: dt.reported_by,
        date_time: isToday(dt.reported_time) ? (
          <HighlightedCell bgcolor="#2669EF">{formatDate(dt.reported_time)}</HighlightedCell>
        ) : (
          formatDate(dt.reported_time)
        ),
        description: dt.description || "",
        details: { ...dt },
        resolved_time: dt.resolved_time || "",
        resolutionTime: resolutionTime

      }
    });
  };

  return {
    formReservationListRows,
    ReservationListHeader: [
      {
        id: 'request_id',
        label: 'Request ID',
        flex: 1,
        accessor: 'request_id',
        align: 'left',
        headerStyle: { backgroundColor: '#2196F3', color: 'white' }
      },
      {
        id: 'room_no',
        label: 'Room No.',
        flex: 1,
        accessor: 'room_no',
        align: 'center',
        headerStyle: { backgroundColor: '#2196F3', color: 'white' }
      },
      // {
      //   id: 'room_type',
      //   label: 'Room Type',
      //   flex: 1,
      //   accessor: 'room_type',
      //   align: 'center',
      //   headerStyle: { backgroundColor: '#2196F3', color: 'white' }
      // },
      {
        id: 'issue_category',
        label: 'Issue Category',
        flex: 1,
        accessor: 'issue_category',
        align: 'center',
        headerStyle: { backgroundColor: '#2196F3', color: 'white' }
      },
      {
        id: 'priority',
        label: 'Priority',
        flex: 1,
        accessor: 'priority',
        align: 'center',
        headerStyle: { backgroundColor: '#2196F3', color: 'white' }
      },
      {
        id: 'status',
        label: 'Status',
        flex: 0.8,
        accessor: 'status',
        align: 'center',
        headerStyle: { backgroundColor: '#2196F3', color: 'white' }
      },
      {
        id: 'reported_by',
        label: 'Reported By',
        flex: 0.5,
        accessor: 'reported_by',
        align: 'center',
        headerStyle: { backgroundColor: '#2196F3', color: 'white' }
      },
      {
        id: 'resolutionTime',
        label: 'Resolution Time',
        flex: 1,
        accessor: 'resolutionTime',
        align: 'center',
        headerStyle: { backgroundColor: '#2196F3', color: 'white' }
      },
      // {
      //   id: 'date_time',
      //   label: 'Date & Time',
      //   flex: 1,
      //   accessor: 'date_time',
      //   align: 'center',
      //   headerStyle: { backgroundColor: '#2196F3', color: 'white' }
      // },
    ],
  };
}